// extracted by mini-css-extract-plugin
export default {"banner_box":"index_banner_box_pAIBq","banner":"index_banner_zFGMx","brandImgUrl":"index_brandImgUrl_CxHTe","brandImgLink":"index_brandImgLink_AoDA-"};